module.exports = __webpack_public_path__ + "media/top/icon_map-pin_36x36-23a3beb2.svg";